import { useRef } from 'react';
import { IonModal } from '@ionic/react';
import FlowModalHeader from './FlowModalHeader';
import { focusStepHeading } from './ModalPages/StepLayout';
import { modalToggleStore, toggleStore } from '../../store/Store';
import Profile1 from './ModalPages/Profile1';
import Profile2 from './ModalPages/Profile2';
import Profile3 from './ModalPages/Profile3';
import Profile4 from './ModalPages/Profile4';
import Profile5 from './ModalPages/Profile5';
import '../../theme/FlowModal.css';

export const PROFILE_STEPS = 5;

const STEP_COMPONENTS = {
    1: Profile1,
    2: Profile2,
    3: Profile3,
    4: Profile4,
    5: Profile5,
};

/**
 * Account set-up: five steps collecting name, phone, address and alert
 * preferences. The modal is open whenever profilePage is above zero.
 */
function ProfileModal() {
    const profilePage = modalToggleStore.useState((s) => s.profilePage);
    const modalRef = useRef(null);
    // Keep showing the last step while the closing animation runs.
    const lastPage = useRef(1);
    if (profilePage > 0) {
        lastPage.current = profilePage;
    }
    const page = profilePage > 0 ? profilePage : lastPage.current;
    const Step = STEP_COMPONENTS[page] || Profile1;

    const closeModal = () => {
        modalToggleStore.update((s) => {
            s.profilePage = 0;
        });
    };

    const goBack = () => {
        modalToggleStore.update((s) => {
            s.profilePage = Math.max(1, s.profilePage - 1);
        });
    };

    const handleDismiss = () => {
        toggleStore.update((s) => {
            s.manualAddress = false;
        });
        closeModal();
    };

    const handlePresent = () => {
        window.setTimeout(() => focusStepHeading(modalRef.current), 0);
    };

    return (
        <IonModal
            ref={modalRef}
            className='flow-modal'
            isOpen={profilePage > 0}
            onDidDismiss={handleDismiss}
            onDidPresent={handlePresent}
        >
            <FlowModalHeader
                title={`Step ${page} of ${PROFILE_STEPS}`}
                step={page}
                totalSteps={PROFILE_STEPS}
                onBack={page > 1 ? goBack : undefined}
                onClose={closeModal}
                closeLabel='Close account set-up'
            />
            <Step />
        </IonModal>
    );
}

export default ProfileModal;
